import React, { Fragment } from "react";

interface IProps {
    alertInfo: any;
}

const IDFSexOffender = ({ alertInfo }: any) => {
    const sexOffenderAlertdetails = alertInfo && alertInfo.length > 0 && alertInfo[0].alertDetails && alertInfo[0].alertDetails.sexOffenderAlertItemDetails;

    if (!sexOffenderAlertdetails) {
        return <Fragment></Fragment>;
    }

    return (
        <>
            {sexOffenderAlertdetails.map((alert: any, index: number) => {
                let keys = Object.keys(alert);
                return (
                    <>
                        {" "}
                        {keys.length !== 0 && (
                            <div className="data-row" key={index}>
                                <div className="link-item">
                                    <button
                                        type="button"
                                        aria-expanded="false"
                                        className="link-button"
                                        id={`alert-${index}`}
                                        onClick={() => toggle(`alert-${index}-details`, `alert-${index}`)}
                                    >
                                        <span className="row link-item">
                                            <div role="row" className="data-row condensed row">
                                                <span className="link-title">
                                                    <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                        Show
                                                    </span>
                                                </span>

                                                {alert["Name"] && (
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label" id={`alert-${index}-Full-Name`}>Full Name</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby={`alert-${index}-Full-Name`}>
                                                                {alert["Name"]}
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                )}

                                                {alert["Address"] && (
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label" id={`alert-${index}-Address`}>Address</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div
                                                                className="data-value"
                                                                aria-labelledby={`alert-${index}-Address`}
                                                                dangerouslySetInnerHTML={{ __html: alert["Address"] }}
                                                            ></div>
                                                        </div>
                                                    </Fragment>
                                                )}
                                            </div>
                                        </span>
                                    </button>
                                    <div
                                        className="wallet-details"
                                        key={alert.alertId}
                                        id={`alert-${index}-details`}
                                        style={{ display: "none", backgroundColor: "#F2F2F2" }}
                                        aria-hidden="true"
                                    >
                                        <div role="grid" className="data-grid row-height-xs" id={"alert-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Address" && key !== "Name" && (
                                                            <>
                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`alert-${index}-${key.split(" ").join("")}`}>
                                                                        {key}
                                                                    </div>
                                                                </div>
                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div
                                                                        className="data-value"
                                                                        aria-labelledby={`alert-${index}-${key.split(" ").join("")}`}
                                                                        dangerouslySetInnerHTML={{ __html: alert[key] }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}{" "}
                    </>
                );
            })}
        </>
    );
};

export default IDFSexOffender;
